export default __webpack_public_path__ + "static/media/Ignacio Llerena.8fa10c2d.jpg";